import React from 'react';
import { Icon, Card, Flex, Button } from 'antd-mobile';

export function Empty(props) {
  return <Card full>
    <Card.Body style={{ textAlign: 'center', color: 'grey' }} >
      <Icon type="cross-circle" /><div>无数据</div>
    </Card.Body>
  </Card>

}

export function Loading(props) {
  const { loading, error, wrapperTag, ...restProps } = props
  if (loading) {
    return <div style={{ textAlign: 'center', color: 'grey' }}>
      <Icon type="loading" />
      <div>加载中...</div>
    </div>
  } else if (error) {
    return <Error message={error} />
  }
  return <div {...restProps} className={wrapperTag ? 'inline-style' : ''} />
}

export function Error(props) {
  return <Card full>
    <Card.Body style={{ textAlign: 'center', color: 'red' }} >
      <Icon type="cross-circle" />
      <div>{props.message}</div>
    </Card.Body>
  </Card>
}

export function TitleDescriptions(props) {
  const { title, descriptions } = props;
  return <div>
    <h4 style={{ margin: '4px 0' }}>{title}</h4>
    <div className="little-description overflow-pre">
      {descriptions.map((item, index) => (
        <span key={index}>
          <span>{item}</span>
          {index !== descriptions.length - 1 ?
            <span style={{ padding: '0 5px' }}>|</span>
            : null}
        </span>
      ))}
    </div>
  </div>
}

export function Descriptions(props) {
  const { title, options, rowNum = 1, borderBottom } = props;
  let descriptions = [[]];
  options.forEach((item) => {
    if (descriptions[descriptions.length - 1].length < rowNum) {
      descriptions[descriptions.length - 1].push(item)
    } else {
      descriptions.push([item])
    }
  });
  return <div>
    {title ? <h4>{title}</h4> : null}
    <div >
      {descriptions.map((item, index) => {
        return <Flex key={index} style={{ padding: '4px', borderBottom }} className="overflow-pre">
          {item.map((desc, dindex) => desc.custom ? desc.custom(index) : <Flex.Item key={dindex}>
            <span style={{ fontWeight: 'bold' }}>{desc.label}:</span>
            <span style={{ marginLeft: '8px' }}>{desc.value}</span>
          </Flex.Item>)}
        </Flex>
      })}
    </div>
  </div>
}

export function Radios(props) {
  const { options, value, onChange, style, size, type, activeType } = props;
  return <span style={style}>
    {options.map(item => <Button
      size={size || "small"}
      inline
      style={{ overflow: "initial" }}
      type={item.value === value ? (activeType || "primary") : (type || "")}
      onClick={() => onChange(item.value)}
      key={item.value}>{item.label}</Button>)}
  </span>

}
